module.exports = __webpack_public_path__ + "img/mark_star_7_icon.00f55851.png";